import { Component, EventEmitter, Input, Output } from '@angular/core';
import { RegistroCategoria, RegistroTipo } from 'src/app/shared/models/registriRequest.model';
import { SelectedRegister } from '../registri.model';

@Component({
  selector: 'app-register-selector',
  styles: [`.drop-down-qualifiche { margin-left: 20px; display: inline; }`],
  template: `
    <p>
      Seleziona il registro da stampare
    </p>
    <div>
      <p-dropdown [options]="elencoRegistri" [(ngModel)]="selectedRegister" placeholder="Seleziona un registro"
        optionLabel="nome" (onChange)="selectCategoria($event.value)">
      </p-dropdown>
      <div class="drop-down-qualifiche">
        <p-dropdown *ngIf="selectedRegister" [options]="selectedRegister.registroTipo" [(ngModel)]="selectedTipo"
          optionLabel="nome" (onChange)="selectTipo()" [styleClass]="'drop-down-qualifiche'">

        </p-dropdown>
      </div>
    </div>
  `
})
export class RegisterSelectorComponent {
  @Input() elencoRegistri: RegistroCategoria[] | undefined;
  @Output() selected = new EventEmitter<SelectedRegister>();
  selectedRegister: RegistroCategoria | undefined;
  selectedTipo: RegistroTipo | undefined;
  qualificheDisabled = true;

  public selectCategoria(event: RegistroCategoria): void {
    this.selectedRegister = event;
    this.selectedTipo = event.registroTipo?.[0];
    this.selected.emit({ categoria: this.selectedRegister, tipo: this.selectedTipo });
  }

  public selectTipo(): void {
    this.selected.emit({ categoria: this.selectedRegister!, tipo: this.selectedTipo! });
  }
}
